import Toast from "./toast";

window.addEventListener('beforeunload', (e) => {
    if (window.onbeforeunload) {
        Toast.toastWarning({'title': 'saving_in_progress_alert.title', 'content': 'saving_in_progress_alert.content'});
    }
});
